import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
// @material-ui/core components
import FilterStyles from 'assets/jss/AdsFilter';
import Select from '@material-ui/core/Select/Select';
import MenuItem from '@material-ui/core/MenuItem/MenuItem';
import withStyles from '@material-ui/core/styles/withStyles';

/**
 * @description
 * Get municipalities from specific province
 *
 * @param {Array} provinces - All provinces.
 * @param {Object} selectedProvince - Selected province.
 * @returns {Array} - Municipalities.
 */
const getMunicipalities = (provinces, selectedProvince) => {
  const municipalities = [];
  const province = provinces.find(elem => elem.id === selectedProvince);
  if (province) {
    province.municipalities.map(municipality =>
      municipalities.push(municipality),
    );
  }
  return municipalities;
};

/**
 * @description
 * Stateless component
 *
 * @param {Object} props - Component props.
 */
const LocationSelect = props => {
  const {
    classes,
    selectedProvince,
    selectedMunicipality,
    changeFilter,
    provinces,
    t,
  } = props;
  const municipalities = getMunicipalities(provinces, selectedProvince);
  return (
    <div>
      <Select
        data-cy="adsFilterLocationSelect"
        id="select-category"
        className={classes.categoryDD}
        MenuProps={{
          className: classes.selectMenu,
        }}
        classes={{
          select: classes.select,
        }}
        value={selectedProvince === undefined ? 0 : selectedProvince}
        onChange={e => {
          const { value } = e.target;
          changeFilter({
            province: value,
          });
        }}
        inputProps={{
          name: 'selectProvince',
          id: 'selectProvince',
        }}
      >
        <MenuItem
          key="select-province-all"
          classes={{
            root: classes.selectMenuItem,
            selected: classes.selectMenuItemSelected,
          }}
          value={0}
        >
          {t('common.all')}
        </MenuItem>
        {provinces.map(province => (
          <MenuItem
            id={`select-provinces-${province.id}`}
            key={`select-provinces-${province.id}`}
            classes={{
              root: classes.selectMenuItem,
              selected: classes.selectMenuItemSelected,
            }}
            value={province.id}
          >
            {province.name}
          </MenuItem>
        ))}
      </Select>
      {selectedProvince > 0 && (
        <Select
          data-cy="adsFilterMunicipalitiesSelect"
          className={classes.categoryDD}
          MenuProps={{
            className: classes.selectMenu,
          }}
          classes={{
            select: classes.select,
          }}
          value={selectedMunicipality === undefined ? 0 : selectedMunicipality}
          onChange={e => {
            const { value } = e.target;
            changeFilter({
              municipality: value,
            });
          }}
          inputProps={{
            name: 'selectMunicipalities',
            id: 'selectMunicipalities',
          }}
        >
          <MenuItem
            key="select-municipalities-all"
            classes={{
              root: classes.selectMenuItem,
              selected: classes.selectMenuItemSelected,
            }}
            value={0}
          >
            {t('common.all')}
          </MenuItem>
          {municipalities.map(municipality => (
            <MenuItem
              id={`select-municipalities-${municipality.id}`}
              key={`select-municipalities-${municipality.id}`}
              classes={{
                root: classes.selectMenuItem,
                selected: classes.selectMenuItemSelected,
              }}
              value={municipality.id}
            >
              {municipality.name}
            </MenuItem>
          ))}
        </Select>
      )}
    </div>
  );
};

/**
 * LocationSelect PropTypes
 * @param classes - prop styles received from withStyles
 * @param selectedProvince - prop to know selected province
 * @param selectedMunicipality - prop to know selected municipality
 * @param provinces - prop provinces received from parent
 * @param t - prop from HOC with string translations
 * @callback changeFilter - callback called when selected province
 * or municipality change
 */

LocationSelect.propTypes = {
  classes: PropTypes.instanceOf(Object).isRequired,
  selectedProvince: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  selectedMunicipality: PropTypes.PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  provinces: PropTypes.instanceOf(Array).isRequired,
  changeFilter: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

LocationSelect.defaultProps = {
  selectedProvince: undefined,
  selectedMunicipality: undefined,
};

export default withTranslation()(withStyles(FilterStyles)(LocationSelect));
